import type { ReactNode } from "react"
import { Navigate } from "react-router-dom"
import type { User } from "../types"

type ProtectedRouteProps = {
  user: User | null
  loading: boolean
  children: ReactNode
}

const ProtectedRoute = ({ user, loading, children }: ProtectedRouteProps) => {
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-sm text-muted-foreground">Loading...</div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/sign-in" replace />
  }

  return <>{children}</>
}

export default ProtectedRoute
